export default (implementation = null) => ({
    implementation,
    siteKey: '',
    enabled: false,
    ready: false,
    action: '',
    triggerAction: false,
    token: '',
    reset: false
});